import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseDeleteFeeTemplateProps {
  onSuccess: () => void
  onError: (error: any) => void
}

export const useDeleteFeeTemplate = ({ onSuccess, onError }: UseDeleteFeeTemplateProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['deleteFeeTemplate'],
    mutationFn: async (feeTemplateId?: string) => {
      return privateAxios.delete(`/billing/fee_templates/${feeTemplateId}`)
    },
    onSuccess,
    onError,
  })
}
